import { createContext } from "react";
export const GameInfoContext = createContext();
export const UniformGameInfoContext = createContext();
export const SuperpowersGameInfoContext = createContext();
export const Girl2023InfoContext = createContext();
